module.exports = __webpack_public_path__ + "f4340cb7c013dae588ec7ec4fd8e4e51.png";